export { default as Img200 } from './processed/200/LifeBelowZero_eBoard.jpg';
export { default as Img400 } from './processed/400/LifeBelowZero_eBoard.jpg';
export { default as Imgthumb } from './processed/thumb/LifeBelowZero_eBoard.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/LifeBelowZero_eBoard.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/LifeBelowZero_eBoard.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      191,
      64,
      96
    ],
    "_population": 0
  },
  "DarkVibrant": {
    "_rgb": [
      12,
      4,
      6
    ],
    "_population": 233,
    "_hsl": [
      0.9583333333333334,
      0.5,
      0.03137254901960784
    ]
  },
  "Muted": {
    "_rgb": [
      158,
      119,
      92
    ],
    "_population": 13,
    "_hsl": [
      0.06818181818181819,
      0.264,
      0.4901960784313726
    ]
  },
  "LightMuted": {
    "_rgb": [
      179,
      164,
      161
    ],
    "_population": 3333,
    "_hsl": [
      0.027777777777777953,
      0.10588235294117641,
      0.6666666666666666
    ]
  },
  "DarkMuted": {
    "_rgb": [
      100,
      52,
      60
    ],
    "_population": 1,
    "_hsl": [
      0.9722222222222222,
      0.3157894736842105,
      0.2980392156862745
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/LifeBelowZero_eBoard.js